import { PayPalCheckout, renderPayPalThankYou } from './paypal.components';
import { SquareCheckout, renderSquareThankYou } from './square.components';
import { StripeCheckout, renderStripeThankYou } from './stripe.components';
import { normalizeEmail } from '../foundation/utilities';
function getSquareCheckoutProps(config, checkoutData) {
    const square = config?.integrations?.square || {};
    const checkoutEmail = normalizeEmail(checkoutData?.shippingTo?.email);
    const sandboxEmails = Array.isArray(square?.sandboxSquareEmails)
        ? square.sandboxSquareEmails.map((value) => normalizeEmail(value))
        : [];
    const explicitSandbox = square?.environment === 'sandbox';
    const useSandbox = explicitSandbox || Boolean(checkoutEmail && sandboxEmails.includes(checkoutEmail));
    const productionApplicationId = square?.squareApplicationId;
    const productionLocationId = square?.squareLocationId;
    const sandboxApplicationId = square?.sandboxSquareApplicationId;
    const sandboxLocationId = square?.sandboxSquareLocationId;
    return {
        applicationId: useSandbox ? sandboxApplicationId : productionApplicationId,
        locationId: useSandbox ? sandboxLocationId : productionLocationId,
        useSandbox,
    };
}
export const paymentProviders = {
    paypal: {
        key: 'paypal',
        displayName: 'PayPal',
        component: PayPalCheckout,
        isConfigured: (config) => Boolean(config?.integrations?.paypal?.payPalApiKey || config?.integrations?.paypal?.sandboxPayPalApiKey),
        getProps: (config, checkoutData, callbacks) => {
            const paypal = config?.integrations?.paypal;
            const email = checkoutData?.shippingTo?.email?.toString().trim().toLowerCase();
            const sandboxEmails = Array.isArray(paypal?.sandboxPayPalEmails)
                ? paypal.sandboxPayPalEmails.map((value) => value.toString().trim().toLowerCase())
                : [];
            const useSandbox = Boolean(email && sandboxEmails.includes(email));
            return {
                payPalClientID: useSandbox
                    ? paypal?.sandboxPayPalApiKey || ''
                    : paypal?.payPalApiKey || '',
                payPalSecret: useSandbox
                    ? paypal?.sandboxPayPalSecret || ''
                    : paypal?.payPalSecret || '',
                payPalApiBaseUrl: useSandbox
                    ? paypal?.sandboxPayPalApiBaseUrl || ''
                    : paypal?.prodPayPalApiBaseUrl || '',
            };
        },
        renderThankYou: renderPayPalThankYou,
    },
    square: {
        key: 'square',
        displayName: 'Square',
        component: SquareCheckout,
        isConfigured: (config) => {
            const props = getSquareCheckoutProps(config);
            return Boolean(props.applicationId && props.locationId);
        },
        getProps: (config, checkoutData, callbacks) => {
            const props = getSquareCheckoutProps(config, checkoutData);
            return {
                applicationId: props.applicationId || '',
                locationId: props.locationId || '',
                ...(callbacks?.onPaymentCapture ? { onSquarePaymentCapture: callbacks.onPaymentCapture } : {}),
            };
        },
        renderThankYou: renderSquareThankYou,
    },
    stripe: {
        key: 'stripe',
        displayName: 'Stripe',
        component: StripeCheckout,
        isConfigured: () => false,
        getProps: (_config, _checkoutData, _callbacks) => ({}),
        renderThankYou: renderStripeThankYou,
    },
};
export function getActivePaymentProvider(config) {
    const requested = config?.integrations?.shoppingcart?.provider?.toString().toLowerCase();
    const priority = ['square', 'paypal', 'stripe'];
    const providerOrder = requested && priority.includes(requested)
        ? [requested, ...priority.filter((provider) => provider !== requested)]
        : priority;
    return providerOrder
        .map((providerKey) => paymentProviders[providerKey])
        .find((provider) => provider.isConfigured(config));
}
